import { ActionTree } from "vuex";
import { MasterState } from "./types";
import { RootState } from "@/store/types";

export const actions: ActionTree<MasterState, RootState> = {};
